<template>
    <div class='main-product-image-size'>
        <Placeholder class='product-image-placeholder'/>
    </div>
</template>

<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}
}
</script>

<style lang="scss" scoped>
.main-product-image-size{
    height: 1000px;
}
</style>